export const getData = state => state.reportDriverPerformanceAnalysis.getIn(['list', 'data'])
export const getFetching = state => state.reportDriverPerformanceAnalysis.getIn(['list', 'fetching'])
export const getError = state => state.reportDriverPerformanceAnalysis.getIn(['list', 'error'])

export const getDetailsData = state => state.reportDriverPerformanceAnalysis.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportDriverPerformanceAnalysis.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportDriverPerformanceAnalysis.getIn(['details', 'error'])
